import { takeLatest, put } from "redux-saga/effects";
import { message } from "antd";
import { fetcher, handleError, getErrorMsg } from "lib/fetch";
import {
  loadCustomers, LOAD_CUSTOMERS,
  loadContacts, LOAD_CONTACTS,
  loadLineUsers, LOAD_LINE_USERS,
  loadVerifiedUsers, LOAD_VERIFIED_USERS,
  exportCustomers, EXPORT_CUSTOMERS,
  exportContacts, EXPORT_CONTACTS,
  exportVerifiedUsers, EXPORT_VERIFIED_USERS,
} from "./actions";

function* handleLoadCustomers(action) {
  try {
    const { params, token } = action.payload;
    const response = yield fetcher.post("customer/customers", params, token);
    yield put(loadCustomers.success(response.data));
  } catch (error) {
    handleError(error);
    yield put(loadCustomers.failure(error));
  }
}

function* handleLoadContacts(action) {
  try {
    const { params, token } = action.payload;
    const response = yield fetcher.post("customer/contacts", params, token);
    yield put(loadContacts.success(response.data));
  } catch (error) {
    handleError(error);
    yield put(loadContacts.failure(error));
  }
}

function* handleLoadLineUsers(action) {
  try {
    const { params, token } = action.payload;
    const response = yield fetcher.post("customer/lineusers", params, token);
    yield put(loadLineUsers.success(response.data));
  } catch (error) {
    handleError(error);
    yield put(loadLineUsers.failure(error));
  }
}

function* handleLoadVerifiedUsers(action) {
  try {
    const { params, token } = action.payload;
    const response = yield fetcher.post("customer/verified-users", params, token);
    yield put(loadVerifiedUsers.success(response.data));
  } catch (error) {
    handleError(error);
    yield put(loadVerifiedUsers.failure(error));
  }
}

function* handleExportCustomers(action) {
  try {
    const { token } = action.payload;
    const res = yield fetcher.post("customer/customers/export", {}, token);
    yield put(exportCustomers.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    message.error("ส่งออกข้อมูลลูกค้าล้มเหลว: " + getErrorMsg(error));
    yield put(exportCustomers.failure(getErrorMsg(error)));
  }
}

function* handleExportContacts(action) {
  try {
    const { token } = action.payload;
    const res = yield fetcher.post("customer/contacts/export", {}, token);
    yield put(exportContacts.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    message.error("ส่งออกข้อมูลผู้ติดต่อล้มเหลว: " + getErrorMsg(error));
    yield put(exportContacts.failure(getErrorMsg(error)));
  }
}

function* handleExportVerifiedUsers(action) {
  try {
    const { token } = action.payload;
    const res = yield fetcher.post("customer/verified-users/export", {}, token);
    yield put(exportVerifiedUsers.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    message.error("ส่งออกข้อมูลลูกค้าลงทะเบียนล้มเหลว: " + getErrorMsg(error));
    yield put(exportVerifiedUsers.failure(getErrorMsg(error)));
  }
}

export default function* watchCustomerSaga() {
  yield takeLatest(LOAD_CUSTOMERS.REQUEST, handleLoadCustomers);
  yield takeLatest(LOAD_CONTACTS.REQUEST, handleLoadContacts);
  yield takeLatest(LOAD_LINE_USERS.REQUEST, handleLoadLineUsers);
  yield takeLatest(LOAD_VERIFIED_USERS.REQUEST, handleLoadVerifiedUsers);
  yield takeLatest(EXPORT_CUSTOMERS.REQUEST, handleExportCustomers);
  yield takeLatest(EXPORT_CONTACTS.REQUEST, handleExportContacts);
  yield takeLatest(EXPORT_VERIFIED_USERS.REQUEST, handleExportVerifiedUsers);
}
